// extracted by mini-css-extract-plugin
module.exports = {"title":"dd31006766--title--1f__H","icon-wrapper":"dd31006766--icon-wrapper--5sA0g"};